import React, { memo, useState } from 'react'
import { Modal, notification, Spin } from 'antd'
import { post } from '../helpers/api_helper';
import { useSelector } from 'react-redux';

const Billing = memo(function Billing({ children }) {
    const [loading, setLoading] = useState(false)
    const user = useSelector((state) => state.UserReducer.user);

    const goToCashRegister = async () => {
        try {
            const token = await localStorage.getItem('h-access_token')
            await setLoading(true)
            const response = await post(`${process.env.REACT_APP_CASH_REGISTER_URL}/api/sso/issue-jwt`, {
                token: token,
                email: user.data.email
            }, {
                'X-App-Name': 'helios',
                'X-App-Token': process.env.REACT_APP_INBOUND_APP_TOKEN
            })
            if (response.data.url) {
                setLoading(false)
                window.open(response.data.url, '_blank');
            } else {
                setLoading(false)
                notification.open({
                    type: 'error',
                    message: 'Alert!',
                    description: `No URL returned`
                });
            }
        } catch (e) {
            console.log(e)
            setLoading(false)
        }
    }

    return (
        <>
            <div className='cursor w-fit' onClick={() => goToCashRegister()}>
                {children}
            </div>
            <Modal title={''} closable={false} open={loading} footer={null} width={0} centered >
                <Spin size='large' />
            </Modal>
        </>
    )
})

export default Billing